import { useState } from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";

interface PrayerTrackerProps {
  day: number;
  prayers: Record<number, string[]>; // day -> completed prayers
  onToggle: (day: number, prayer: string) => void;
}

const PRAYERS = [
  { id: "fajr", name: "Fajr", time: "Dawn" },
  { id: "dhuhr", name: "Dhuhr", time: "Noon" },
  { id: "asr", name: "Asr", time: "Afternoon" },
  { id: "maghrib", name: "Maghrib", time: "Sunset" },
  { id: "isha", name: "Isha", time: "Night" },
];

export const PrayerTracker = ({ day, prayers, onToggle }: PrayerTrackerProps) => {
  const completedPrayers = prayers[day] || [];
  const completedCount = completedPrayers.length;

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <span className="text-xs uppercase tracking-[0.15em] text-muted-foreground">
          Day {day}
        </span>
        <span className="text-xs text-muted-foreground">
          {completedCount}/5 prayers
        </span>
      </div>

      <div className="grid grid-cols-5 gap-2">
        {PRAYERS.map((prayer) => {
          const isCompleted = completedPrayers.includes(prayer.id);
          return (
            <motion.button
              key={prayer.id}
              onClick={() => onToggle(day, prayer.id)}
              className={`
                flex flex-col items-center p-3 rounded-sm transition-all
                ${isCompleted 
                  ? "bg-gold/20 border border-gold/40" 
                  : "bg-background border border-border hover:border-gold/30"
                }
              `}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              {isCompleted ? (
                <Check className="w-4 h-4 text-gold mb-1" />
              ) : (
                <div className="w-4 h-4 rounded-full border border-muted-foreground/30 mb-1" />
              )}
              <span className={`text-xs font-medium ${isCompleted ? "text-gold" : "text-foreground/70"}`}>
                {prayer.name}
              </span>
            </motion.button>
          );
        })}
      </div>
    </div>
  );
};
